import { useCallback } from "react";
import StandaloneSurveyPageLayout from "components/v3/layouts/StandaloneSurveyPageLayout";
import CancerSurvey from "components/v3/sharedComponents/surveys/CancerSurvey";
import { trackSurveyAbandonAttempted } from "analytics";

const CancerSurveyPage = (): React.ReactElement => {
  const handleExitClick = useCallback(() => {
    trackSurveyAbandonAttempted({
      surveyId: "detailed-cancer-survey",
      workflow: "cancer_survey",
      action: "opened_exit_modal"
    });
  }, []);

  const handleExitModalClose = useCallback(() => {
    trackSurveyAbandonAttempted({
      surveyId: "detailed-cancer-survey",
      workflow: "cancer_survey",
      action: "cancelled_exit"
    });
  }, []);

  return (
    <StandaloneSurveyPageLayout
      onExitClick={handleExitClick}
      onExitModalClose={handleExitModalClose}
      pageTitle="Precision guidance survey"
      showLogoHeader
    >
      <CancerSurvey />
    </StandaloneSurveyPageLayout>
  );
};

export default CancerSurveyPage;
